(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artema-showroom-opening"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initOpening = (root = document) => {
    const params = new URLSearchParams(window.location.search);
    root.querySelectorAll('[data-ao-utm]').forEach(input => {
      input.value = (params.get(input.dataset.aoUtm) || '').slice(0, 200);
    });
    const success = root.querySelector('[data-ao-success]');
    if (success) {
      success.focus({ preventScroll: true });
      success.scrollIntoView({ block: 'center' });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initOpening());
  else initOpening();
  document.addEventListener('shopify:section:load', event => initOpening(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
